module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "row-key": "id",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "用户信息",
      "fixed": "left",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "cell-img",
          attrs: {
            "src": scope.row.face,
            "alt": ""
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "custom-title"
        }, [_vm._v(_vm._s(scope.row.user_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "身份",
      "prop": "zhuantai"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.user_type) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "caozuo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope, index) {
        return [(scope.row.type != 1) ? _c('el-button', {
          staticClass: "look-order",
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.deleteUser(scope.row.user_id, index)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toUserCreate
    }
  }, [_vm._v("新增用户\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('JianduPicker', {
    attrs: {
      "show": _vm.showJianduPicker,
      "limit": 1,
      "defaultValue": _vm.formData.jiandu
    },
    on: {
      "onChange": _vm.onJianduChange,
      "onClose": function($event) {
        _vm.showJianduPicker = false
      },
      "onConfirm": _vm.onJianduConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9372f1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/QcxjDetailCommunity.vue
// module id = 1560
// module chunks = 0